/**
 * DIEUKYDIEU.TV - AUDIO PLAYER REACTIVE STATE & PREFERENCES
 */

export let currentAudioIndex = -1;
export let isShuffle = false;
export let repeatMode = 0; // 0: off, 1: all, 2: one
export let currentPlaybackSpeed = 1.0;
export let isRemainingTimeMode = true; // Apple Music signature default (-mm:ss)
export let currentLyricIndex = -1;
export let favoriteTracks = (() => {
    try {
        const stored = localStorage.getItem('dkd_player_favorites');
        return stored ? JSON.parse(stored) : [];
    } catch (e) {
        return [];
    }
})();
export let activePlayerTab = 'now-playing';

export function setCurrentAudioIndex(idx) {
    currentAudioIndex = idx;
}

export function setIsShuffle(val) {
    isShuffle = val;
}

export function setRepeatMode(val) {
    repeatMode = val;
}

export function setCurrentPlaybackSpeed(speed) {
    currentPlaybackSpeed = speed;
}

export function setIsRemainingTimeMode(val) {
    isRemainingTimeMode = val;
}

export function setCurrentLyricIndex(idx) {
    currentLyricIndex = idx;
}

export function setActivePlayerTab(tab) {
    activePlayerTab = tab;
}

export function setFavoriteTracks(list) {
    favoriteTracks = list;
}
